import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@material-ui/core'
import { unwrapResult } from '@reduxjs/toolkit'
import { Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'

import { useActionRunner } from 'src/modules/notification'

import Button from './Button'

const FormikDialog = ({
  children,
  initialValues,
  errorNotification,
  fullWidth,
  maxWidth,
  onClick,
  onSubmit,
  open,
  successNotification,
  submitColor,
  submitText,
  title,
  trigger,
  validationSchema,
  onClose,
}) => {
  const [modalOpen, setModalOpen] = useState(open)

  const formRef = useRef()

  useEffect(() => {
    setModalOpen(open)
  }, [open])

  const [doSubmit, isSubmitting] = useActionRunner(onSubmit, {
    successNotification,
    errorNotification,
  })

  const handleShowModal = () => setModalOpen(true)
  const handleCloseModal = () => {
    if (!isSubmitting) {
      setModalOpen(false)
    }
    if (onClose) onClose()
  }

  const handleSubmit = async (values, formikBag) => {
    const { setErrors } = formikBag
    const result = await doSubmit(values, formikBag)
    try {
      unwrapResult(result)
      handleCloseModal()
    } catch (error) {
      setErrors(error.data)
    }
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault()
      formRef.current.submitForm()
    }
  }

  return (
    <>
      {trigger({ onClick: handleShowModal })}
      <Dialog
        fullWidth={fullWidth}
        open={modalOpen}
        maxWidth={maxWidth}
        onClick={onClick}
        onClose={handleCloseModal}
        onKeyDown={handleKeyDown}
      >
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
          innerRef={formRef}
          enableReinitialize
        >
          {({ isSubmitting, handleSubmit }) => (
            <>
              {title && <DialogTitle>{title}</DialogTitle>}
              <DialogContent>{children}</DialogContent>
              <DialogActions>
                <Button onClick={handleCloseModal}>Cancel</Button>
                <Button
                  color={submitColor}
                  isLoading={isSubmitting}
                  onClick={handleSubmit}
                >
                  {submitText}
                </Button>
              </DialogActions>
            </>
          )}
        </Formik>
      </Dialog>
    </>
  )
}

FormikDialog.propTypes = {
  initialValues: PropTypes.object,
  maxWidth: PropTypes.string,
  onClick: PropTypes.func,
  onSubmit: PropTypes.any,
  open: PropTypes.bool,
  submitColor: PropTypes.string,
  submitText: PropTypes.string,
  successNotification: PropTypes.any,
  title: PropTypes.string,
  trigger: PropTypes.func,
  validationSchema: PropTypes.object,
}

FormikDialog.defaultProps = {
  initialValues: {},
  maxWidth: 'md',
  open: false,
  submitColor: 'primary',
  submitText: 'Submit',
}

export default FormikDialog
